import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './Title.styles';

const Title = ({ children }) => (
  <Wrapper>
    {children}
  </Wrapper>
);

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Title;
